// extracted by mini-css-extract-plugin
export default {"index":"email-templates_index__pgVse","body":"email-templates_body__-HnXH"};